import { render, staticRenderFns } from "./BtnInserirAlerta.vue?vue&type=template&id=3d7f4901&"
import script from "./BtnInserirAlerta.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports